// ** Reducers Imports
import navbar from './navbar';
import layout from './layout';
import auth from './authentication';
import permission from './permission';
import crudApis from './allCrudeStore';
import Tabs from './Tabs';

const rootReducer = {
    auth,
    navbar,
    layout,
    permission,
    Tabs,
    ...crudApis
};

export default rootReducer;
